import Vue from 'vue'
import Vuex from 'vuex'
import Procedimento from './http/procedimento'
import Menu from './http/menu'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    operadores: [],
    disponivel: [],
    dataSourceConfig: [],
    configUsuario: [],
    usuario: []
  },

  mutations: {

    setDados(state, payload) {
      state.dataSourceConfig = payload
    },


    SET_OPERADOR(state, payload) {
      state.operadores = payload
    },

    SET_DATASOURCE(state, payload) {
      state.dataSourceConfig = payload
    },

    SET_ConfigUsuario(state, payload) {
      state.configUsuario = payload
    },

    SET_Usuario(state, payload) {
      state.usuario = payload
    },

    getOperadorDisponivel(state) {
      state.disponivel = state.operadores.filter(state.operadores.ic_disponivel == 'Sim');

    }
  },

  actions: {

    async getDados({ commit }) {


      let api = '';

      //this.cd_menu    = 7164;//localStorage.cd_menu;
      //this.cd_api     = 543; //localStorage.cd_api;
      //this.api        = '543/750'; //localStorage.nm_identificacao_api;

      // 
      //localStorage.cd_api  = 543;
      //localStorage.cd_menu = 7164;
      //localStorage.api     = '543/750';

      //console.log(localStorage.cd_empresa);

      var dados = await Menu.montarMenu(localStorage.cd_empresa, localStorage.cd_menu, localStorage.cd_api);
      //
      //console.log(dados);

      api = dados.nm_identificacao_api;

      //console.log(api);

      //let sParametroApi = dados.nm_api_parametro
      localStorage.cd_parametro = 4;

      let sParametroApi = dados.nm_api_parametro;

      let dataSourceConfig = await Procedimento.montarProcedimento(
        localStorage.cd_empresa,
        localStorage.cd_cliente,
        api,
        sParametroApi
      )

      // console.log(dataSourceConfig);
      commit('setDados', dataSourceConfig);

    },


    getOperadorDisponivel({ commit }) {
      commit('getOperadorDisponivel', disponivel);
    },

    async loadOperador({ commit }) {

      let api = '';

      var dados = await Menu.montarMenu(localStorage.cd_empresa, 0, 570);
      //

      api = dados.nm_identificacao_api;

      let sParametroApi = dados.nm_api_parametro

      let operadores = await Procedimento.montarProcedimento(
        localStorage.cd_empresa,
        localStorage.cd_cliente,
        api,
        sParametroApi
      )

      commit('SET_OPERADOR', operadores)
      //console.log('1*');
      //console.log(operadores);

    }
  },
  getters: {
    allDados: (state) => {
      return state.dataSourceConfig
    }
  },
  setter: {

  }
})
